import React from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { useChecklist } from './_load/ChecklistLoader'
import { useModalData } from '../../../components/modals/ModalsContext'
import Separator from '../../../components/helpers/Separator'

const useTitle = () => {
  const { fromTemplates, toTemplates } = useModalData()
  if (fromTemplates) return 'Clonando questionário a partir de um template'
  if (toTemplates) return 'Salvando questionário na base de templates'
  return 'Clonando questionário'
}

const Header = () => {
  const checklist = useChecklist()
  const title = useTitle()

  return (
    <>
      <SmallText>{checklist?.name}</SmallText>
      <Title size="h5">{title}</Title>
      <SmallText>Essa ação irá criar um novo checklist com os mesmos dados do checklist {checklist?.name}</SmallText>
      <Separator weight={6} />
    </>
  )
}

export default Header
